import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { generatedTypesNew } from '@css-xp/graphtypes';
import { DEFAULT_ROWS_PER_PAGE } from '@atlassian/cssxp-utils-entitlement';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { fetchBillingProfilesForTransactionAccountInPPC } from '../queries/fetch-billing-profiles-for-transaction-account';
import { isEmpty } from 'lodash';

interface UseFetchBillingProfilesForTransactionAccountQueryVariables {
  soldToAddressIds?: string[];
  transactionAccountId: string;
  sortOptions?: generatedTypesNew.SortType;
  fetchNodes?: boolean;
  filterOptions?: generatedTypesNew.Maybe<generatedTypesNew.FilterOption>[] | null;
  skipOption?: boolean;
  numberOfBillingProfilesToFetch?: number;
}

const defaultSearchOptions = {
  first: DEFAULT_ROWS_PER_PAGE,
  offset: 0,
};

export const useFetchBillingProfilesForTransactionAccountQuery = ({
  soldToAddressIds,
  transactionAccountId,
  sortOptions,
  fetchNodes = true,
  filterOptions,
  skipOption = false,
  numberOfBillingProfilesToFetch = DEFAULT_ROWS_PER_PAGE,
}: UseFetchBillingProfilesForTransactionAccountQueryVariables) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);
  const defaultFilter = [
    {
      key: 'or',
      // sending multiple ship-to ids
      value: JSON.stringify(soldToAddressIds?.map((shipToId) => ({ shipToId }))),
    },
  ];
  return usePersistedCacheQuery<
    generatedTypesNew.FetchBillingProfilesForTransactionAccountInPpcQuery,
    generatedTypesNew.FetchBillingProfilesForTransactionAccountInPpcQueryVariables
  >(fetchBillingProfilesForTransactionAccountInPPC, {
    variables: {
      id: transactionAccountId,
      searchOptions: {
        ...defaultSearchOptions,
        first: numberOfBillingProfilesToFetch,
        ...(!isEmpty(sortOptions) && { sort: sortOptions }),
      },
      refetchDefaultPaymentMethod: false,
      filterOptions: filterOptions ? [...filterOptions, ...defaultFilter] : defaultFilter,
      fetchNodes: fetchNodes,
    },
    displayName: 'fetchBillingProfilesForTransactionAccountInPPC',
    skip: !transactionAccountId || !soldToAddressIds || !soldToAddressIds.length || skipOption,
    client: ansClient,
  });
};
